import Bugsnag from "@bugsnag/js";
import classNames from "classnames";
import Modal from "kustom-front/src/components/molecules/Modal";
import { FunctionComponent, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { reloadPage } from "@Components/molecules/LoginModal/utils";
import { ReactComponent as IconArrowLeft } from "@Icons/16x16/arrow-left.svg";
import cheerzLogo from "@Images/logo-cheerz.png";
import { ScreenAction, ScreenParams } from "@Types/login";
import Email from "./Email";
import Forgotten from "./Forgotten";
import background from "./images/background.svg";
import Password from "./Password";
import ProvidersChoice from "./ProvidersChoice";
import Welcome from "./Welcome";
import "./style.scss";

interface Props {
  action: ScreenAction;
  callback?: () => Promise<void>;
  display: boolean;
  hide: () => void;
}

const LoginModal: FunctionComponent<Props> = ({ action, callback, display, hide }) => {
  const [active, setActive] = useState<boolean>(false);
  const [screenParams, setScreenParams] = useState<ScreenParams>({
    action,
    screen: "choice",
  });
  const intl = useIntl();

  useEffect(() => {
    const params: ScreenParams = {
      action,
      screen: "choice",
    };
    if (callback) {
      params.page = "customization";
    }
    setScreenParams(params);
  }, [action, callback, display]);

  const handleChangeScreen = (newScreenParams: ScreenParams) => {
    setActive(true);
    setTimeout(() => {
      setScreenParams(newScreenParams);
      setTimeout(() => {
        setActive(false);
      }, 50);
    }, 300);

    if (newScreenParams.screen === "welcome") {
      setTimeout(() => {
        hide();
        setScreenParams({
          action: "signUp",
          screen: "choice",
        });
        callback
          ? callback()
              .then(() => reloadPage())
              .catch(() => {
                Bugsnag.notify(Error("LoginModal callback error"));
              })
          : reloadPage();
      }, 2000);
    }
  };

  const back = () => {
    let backScreenParams: ScreenParams;

    if (screenParams.screen === "email") {
      backScreenParams = { ...screenParams, screen: "choice" };
    } else {
      backScreenParams = { ...screenParams, screen: "email" };
    }
    handleChangeScreen(backScreenParams);
  };

  return (
    <Modal
      display={display}
      onDismiss={() => {
        hide();
        setScreenParams({
          action: "signUp",
          screen: "choice",
        });
      }}
      showCloseButton={false}
    >
      <div
        className={classNames("LoginModal", {
          "LoginModal--active": active,
        })}
        style={
          screenParams.screen !== "email" &&
          screenParams.screen !== "password" &&
          screenParams.screen !== "forgotten"
            ? { backgroundImage: `url(${background})` }
            : {}
        }
      >
        {(screenParams.screen === "email" || screenParams.screen === "password") && (
          <div className="LoginModal-back" onClick={back}>
            <IconArrowLeft />
            <span>{intl.formatMessage({ id: "cheerz_LoginModal_back" })}</span>
          </div>
        )}
        {screenParams.screen !== "welcome" && (
          <div className="LoginModal-logo">
            <img alt="Cheerz" src={cheerzLogo} />
          </div>
        )}
        {screenParams.screen === "choice" && (
          <ProvidersChoice onChangeScreen={handleChangeScreen} params={screenParams} />
        )}
        {screenParams.screen === "email" && (
          <Email onChangeScreen={handleChangeScreen} params={screenParams} />
        )}
        {screenParams.screen === "forgotten" && (
          <Forgotten onChangeScreen={handleChangeScreen} params={screenParams} />
        )}
        {screenParams.screen === "password" && (
          <Password onChangeScreen={handleChangeScreen} params={screenParams} />
        )}
        {screenParams.screen === "welcome" && <Welcome params={screenParams} />}
      </div>
    </Modal>
  );
};

export default LoginModal;
